import React, {useState} from 'react'
import { Box,Spinner,Layer} from 'grommet';
import CreateQuoteForm from '../../components/createQuoteForm'
import {withRouter} from 'react-router-dom'
import moment from 'moment'
import { API,Auth } from 'aws-amplify';

const returnQuote = (quote) => {
  var formattedQuote = quote;
  formattedQuote.origin.country = quote.OriginCountry
  formattedQuote.origin.city = quote.OriginCity
  formattedQuote.origin.postcode = quote.OriginPostCode 
  formattedQuote.destination.country = quote.DestinationCountry
  formattedQuote.destination.city = quote.DestinationCity
  formattedQuote.destination.postcode = quote.DestinationPostCode
  formattedQuote.transit_details = {Packages:[{Number: 1, Weight: quote.quoted_weight, Dimensions:{Length: quote.length, Width: quote.width, Height: quote.height}}], PickupDateTime: quote.PickupDateTime}
  delete formattedQuote.length
  delete formattedQuote.width
  delete formattedQuote.height
  delete formattedQuote.OriginCountry
  delete formattedQuote.OriginCity
  delete formattedQuote.OriginPostCode 
  delete formattedQuote.DestinationCountry
  delete formattedQuote.DestinationCity
  delete formattedQuote.DestinationPostCode
  delete formattedQuote.PickupDateTime
  return formattedQuote
}

function CreateQuote(props){
    const [quote, setQuote] = useState()
    const [load, setLoad] = useState(false)
    React.useEffect(() => {    
      if (props.location.hasOwnProperty('data')){
        var prevQuote = props.location.data.quote
        var currentQuote = {category: 'new_quick_quote_request', user: sessionStorage.getItem('username'), quoted_weight: "1", origin: {}, destination: {}, transit_details: {}, PickupDateTime: moment().format()}
        currentQuote.OriginCountry = prevQuote.origin.country
        currentQuote.DestinationCountry = prevQuote.destination.country
        currentQuote.origin.country = prevQuote.origin.country
        currentQuote.destination.country = prevQuote.destination.country
        currentQuote.OriginCity = prevQuote.origin.city
        currentQuote.OriginPostCode = prevQuote.origin.postcode
        currentQuote.Destination = prevQuote.destination.country
        currentQuote.DestinationCity = prevQuote.destination.city
        currentQuote.DestinationPostCode = prevQuote.destination.postcode
        currentQuote.length = prevQuote.transit_details.Packages[0].Dimensions.Length
        currentQuote.width = prevQuote.transit_details.Packages[0].Dimensions.Width
        currentQuote.height = prevQuote.transit_details.Packages[0].Dimensions.Height
        setQuote(currentQuote)
      } else {
        setQuote({category: 'new_quick_quote_request', user: sessionStorage.getItem('username'), quoted_weight: "1", origin: {}, destination: {}, transit_details: {}, PickupDateTime: moment().format()})
      }
    },[props]);
    const handleSubmit = () => {
        setLoad(true)
        const newQuote = returnQuote(quote)
        Auth.currentSession().then(session => {
          API
          .post("LabShip", "/quotes",
          { headers: { 
            Authorization: session.idToken.jwtToken,
          }, 
          body:{quote: newQuote}})
          .then(quote => {
            setLoad(false)
            if (quote.status === 'success'){
              props.history.push({
                pathname: '/quote/success',
                state: { quote: quote,error:false }
              })
            } else {
              setLoad(false)
              props.history.push({
                pathname: '/quote/fail',
                state: { quote: quote,error:false }
              })
            }
          }).catch(err => {
            setLoad(false)
            props.history.push({
              pathname: '/quote/fail',
              state: { error: true , quote: quote}
            })
          })
        })
       }
       let view;
       if (load){
         view = (
          <Layer>
          <Box align='center' justify='center' direction='column' margin="medium" width='xsmall' height='xsmall'>
            <Spinner />
          </Box>
        </Layer>
          )
       } else {
        view = <CreateQuoteForm requote={props.location.requote} user={props.user} handleSubmit={handleSubmit} quote={quote} setQuote={setQuote} size={props.size}/>
       }
    return (
        view
    )

}

export default withRouter(CreateQuote)